import { ListItem, ListItemLabel } from "baseui/list";
import { ValueDisplay } from "../../components/ValueDisplay";
import { ICO2Rate } from "./types";
import { MdCo2 } from "react-icons/md";
import { NotificationCircle } from "baseui/badge";
import { useStyletron } from "baseui";
import { useIntl } from "react-intl";


interface CO2RateProps extends ICO2Rate {
    endEnhancers?: any,
    referencedCounters?: number
}
const CO2RateListItem = (props: CO2RateProps) => {
    const [css,theme] = useStyletron();
    const intl = useIntl();
    const unitText = intl.formatMessage({id: "unit", defaultMessage: 'Unit'});
    return (
        <ListItem
            key={props.id}
            artwork={() => <MdCo2 color={theme.colors.positive400} size={'2em'}></MdCo2>}
            artworkSize={'SMALL'}
            endEnhancer={() => (
                <>
                    <ValueDisplay small value={props.valuePerUnit} dimension={`kg/${unitText}`}></ValueDisplay>
                    {props.endEnhancers}
                </>
            )}        >
            <ListItemLabel>{props.name} {((props.referencedCounters ?? 0) > 0) && <NotificationCircle color={'accent'} content={props.referencedCounters} />}</ListItemLabel>
        </ListItem>
    )
}

export default CO2RateListItem;